import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Surface, useTheme } from 'react-native-paper';
// import type { AssetNode, ProjectData } from "../../types/project"
import type { TabComponentProps } from "../../types/tabs"

// interface ModelTabProps {
//   selectedNode?: AssetNode | null
//   projectData?: ProjectData | null
// }

export const ModelTab: React.FC<TabComponentProps> = ({ selectedNode, projectData }) => {
    const theme = useTheme();

    if (!selectedNode) {
        return (
            <Surface style={[styles.container, { backgroundColor: theme.colors.elevation.level1 }]}>
                <Text style={{ color: theme.colors.onSurface }}>Please select a node to view 3D model</Text>
            </Surface>
        );
    }

    return (
        <Surface style={[styles.container, { backgroundColor: theme.colors.elevation.level1 }]}>
            <Text style={{ color: theme.colors.onSurface }}>
                3D Model for node: {selectedNode.name}
            </Text>
            {/* Add your 3D model visualization here */}
        </Surface>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
    }
});
